import { Marker, Popup } from 'react-leaflet';
import React, { ReactElement } from 'react';
import { depotIcon } from '../Common/MapIcons';
// @ts-ignore
import decodePolyline from 'decode-google-map-polyline';
import { RoutePolyline } from '@/types/openapi_internal';
import { Color } from '@/config/types/Routes';
import { Address } from '@/types/openapi';
import { depotIconSvg } from '../Common/textMarkerMaker';
import L from 'leaflet';

export default {
  assemblePolyline({ route_polyline, routepolyline, id }: any, color: string) {
    try {
      const coords = decodePolyline(route_polyline || routepolyline);
      if (!Array.isArray(coords) || !coords.length) {
        console.warn(` No coords decoded for route ${id}`);
        return { routeId: id, coordinates: [], color };
      }

      return {
        routeId: id,
        coordinates: coords,
        color
      };
    } catch (err) {
      console.error(`Error decoding polyline for ${id}`, err);
      return {
        routeId: id,
        coordinates: [],
        color
      };
    }
  },

  getPolylines(routestrings: RoutePolyline[], colors: { [key: string]: Color }) {
    const polylineObjectArray: any[] = [];

    if (!routestrings || !routestrings.length) {
      return polylineObjectArray;
    }
    return routestrings.map((routestring) => {
      const { color } = colors[routestring.id] || { color: '#1976d2' };
      return this.assemblePolyline(routestring, color);
    });
  },

  renderDepotIcons(depots: Address[]) {
    if (depots.length) {
      return depots
        .map(({ id, location }, i) => {
          const coords = location.coordinates;
          return (<Marker
            // @ts-ignore 
            style={{ zIndex: 100 }}
            icon={depotIcon}
            position={[coords[1], coords[0]]}
            id={`depotmarker_${id}_${i}`}
            key={`${id}_${i}`}
          />);
        });
    }
    return null;
  },
  renderDepotMarkerFromLocation(depotLocation: {
    coordinates?: { latitude: number; longitude: number };
    address?: {
      street?: string;
      house_number?: string;
      postal_code?: string;
      city?: string;
      country?: string;
    };
  }): React.ReactElement | null {
    if (!depotLocation?.coordinates) return null;

    const { latitude, longitude } = depotLocation.coordinates;
    if (typeof latitude !== 'number' || typeof longitude !== 'number') return null;

    const { street, house_number, postal_code, city, country } = depotLocation.address || {};

    return (
      <Marker
        icon={L.icon({
          iconUrl: 'data:image/svg+xml;utf8,' + encodeURIComponent(depotIconSvg()),
          iconSize: [55, 65],
          iconAnchor: [27, 48],
        })}
        position={[latitude, longitude]}
        // @ts-ignore
        style={{ zIndex: 100 }}
      >
      </Marker>
    );
  }
};
